<template>
  <vx-card no-shadow>

    <div class="vx-row">
      <div class="mb-4 vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <div>
            <p v-if="student_data" class="text-lg font-medium mb-2 mt-4" sm:mt-0>{{ student_data.name  }}({{ student_data.studentID  }})</p>
          </div>
        </div>
      </div>
    </div>
     <div v-if="student_data" class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <table width="100%">
            <tr>
              <td class="font-semibold" width="30%"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>학년구분</td>
              <td>{{ schoolType }} / {{ schoolGrade  }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>학교명</td>
              <td>{{ student_data.schoolName }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>학생 휴대폰번호</td>
              <td>{{ student_data.mobilephone }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>전화번호</td>
              <td>{{ student_data.telephone }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>생년월일</td>
              <td>{{ student_data.birthDay  }} ({{ isLunar }}) ({{ gender }})</td>
            </tr>
          </table>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <table width="100%">
            <tr>
              <td class="font-semibold" width="30%"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>우편번호</td>
              <td>{{ student_data.zipCode }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>주소</td>
              <td>{{ student_data.zipName }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>주소세부</td>
              <td>{{ student_data.zipDetail  }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>입학일</td>
              <td>{{ student_data.schoolEnterDate  }}</td>
            </tr>
            <tr>
              <td class="font-semibold"><feather-icon icon="CircleIcon" svgClasses="w-3 h-3 stroke-current mr-1 mt-1 text-primary"/>담당강사</td>
              <td>{{ student_data.teacherID }}</td>
            </tr>
          </table>
        </div>
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">확인</vs-button>
    </div>
  </vx-card>
</template>

<script>
import { fetchData } from '@/api/module'

export default {
  data () {
    return {
      student_data: null,
      userInfo: null
    }
  },
  computed: {
    schoolType () {
      const schoolType = this.student_data.schoolType
      if (schoolType === 0) {
        return '초등'
      } else if (schoolType === 1) {
        return '중등'
      } else if (schoolType === 2) {
        return '고등'
      } else {
        return ''
      }
    },
    schoolGrade () {
      return `${ this.student_data.schoolGrade + 1 }학년`
    },
    isLunar () {
      if (this.student_data.isLunar === 0) {
        return '양력'
      } else {
        return '음력'
      }
    },
    gender () {
      if (this.student_data.gender === 0) {
        return '남'
      } else {
        return '여'
      }
    }
  },
  methods: {
    async fetchStudentInfo () {
      try {
        const studentID = this.userInfo.userID
        const { data } = await fetchData(`student/${studentID}`)
        this.student_data = data.data
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    this.fetchStudentInfo()
  }
}
</script>
